import React, { Fragment } from "react";
import Media from "@qlik/qlik/src/components/Media";
import Cta from "@qlik/qlik/src/components/Cta";
import { getSpacingClassName } from "@qlik/qlik/src/lib/util/spacing";
import { getColorClassName } from "@qlik/qlik/src/lib/util/colors";
import RichText from "@qlik/qlik/src/components/RichText";
import { renderSanitizedHtmlContent } from "@qlik/qlik/src/lib/util/helpers";
import * as styles from "./styles.module.css";

const LogoWallSliding = ({ data }) => {
    const { title, subtitle, body, cta = [], cardCollections = [], customId } = data ?? {};

    const cloneLogoCards = (cards) => {
        let clonedDataSet = [];
        // eslint-disable-next-line no-unsafe-optional-chaining
        for (let i = 0; i < Math.ceil(50 / cards?.length); i += 1) {
            clonedDataSet = clonedDataSet.concat([...cards]);
        }
        return clonedDataSet;
    };

    const spacingClassName = getSpacingClassName(data?.additionalConfiguration, "pt-15.5 pb-12.5 lg:pt-20 lg:pb-20");
    const { sectionColorMapping } = getColorClassName(data?.backgroundColor);

    return (
        <section
            className={`overflow-hidden relative ${spacingClassName} ${sectionColorMapping?.bgColor || "bg-white"}`}
            id={customId}
        >
            <div key={data.id}>
                <div className="container">
                    {subtitle && <div className="tag-1 uppercase text-center mb-5 lg:mb-3.5">{subtitle}</div>}
                    {title && (
                        <h2
                            className="m-auto text-center text-blue"
                            // eslint-disable-next-line react/no-danger
                            dangerouslySetInnerHTML={{ __html: renderSanitizedHtmlContent(title) }}
                        />
                    )}
                    {body && <RichText data={data} className={`text-center mt-5 ${styles.bodyText}`} />}
                    <div className="flex justify-center mt-5 lg:mt-7.5">
                        {cta?.map((button) => (
                            <div key={button.id}>
                                <Cta key={button.id} data={button} />
                            </div>
                        ))}
                    </div>
                </div>
                <div>
                    {cardCollections?.map((item, index) => (
                        <div key={`${item.id}_${index}`}>
                            {cardCollections?.length > 1 ? (
                                <div
                                    className={`inline-flex logo-list ${
                                        index === 0
                                            ? "animate-slider-rtl mt-15 md:mt-20"
                                            : "animate-slider-ltr mt-5 md:mt-10"
                                    }`}
                                >
                                    <div className="flex">
                                        {cloneLogoCards(item?.cardItems)?.map((logo, logIndex) => (
                                            // eslint-disable-next-line react/no-array-index-key
                                            <Fragment key={`${logo.id}_${logIndex}`}>
                                                {logo?.media?.[0] && (
                                                    <div className="flex flex-col rounded-sm w-30 h-[135px] lg:w-40 lg:h-45 shadow-lg ml-10">
                                                        <div className="pt-5 w-[49px] lg:w-auto lg:pt-7 mx-auto">
                                                            <Media
                                                                className="w-auto mx-auto min-h-10 lg:max-w-[115px] lg:min-h-[66px] max-h-[66px] object-scale-down"
                                                                media={logo?.media?.[0]}
                                                            />
                                                        </div>
                                                        {logo.title && (
                                                            <div className="px-3.75 pb-4.5 lg:p-5 flex h-full items-end justify-center">
                                                                <p className="text-xxs lg:text-sm text-center text-gray font-medium">
                                                                    {logo.title}
                                                                </p>
                                                            </div>
                                                        )}
                                                    </div>
                                                )}
                                            </Fragment>
                                        ))}
                                    </div>
                                </div>
                            ) : (
                                <div
                                    className={`mt-10.5 inline-flex logo-list animate-slider-rtl ${
                                        cta === null ? "md:mt-12.5" : "md:mt-20"
                                    } `}
                                >
                                    <div className="flex">
                                        {cloneLogoCards(item.cardItems)?.map((logo, logIndex) => (
                                            // eslint-disable-next-line react/no-array-index-key
                                            <Fragment key={`${logo.id}_${logIndex}`}>
                                                {logo?.media?.[0] && (
                                                    <div className="flex items-center justify-center rounded-sm w-[246px] h-[135px] lg:w-70 lg:h-45 shadow-lg ml-10">
                                                        <div className="flex justify-center">
                                                            <Media
                                                                lazyLoad={false}
                                                                className="max-w-[193px] h-26.5 object-scale-down"
                                                                media={logo?.media?.[0]}
                                                            />
                                                        </div>
                                                    </div>
                                                )}
                                            </Fragment>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default LogoWallSliding;
